import axios from "axios";
import store from '../store/index';
 
const jwtInterceptor = axios.create({});

jwtInterceptor.interceptors.request.use((config) => {
    
    const authData = localStorage.getItem('access_token');
    
    if (authData == null) {
      return config;
    }
  
    config.headers.common["Authorization"] = `bearer ${authData}`;
    return config;
  });
  
  jwtInterceptor.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const originalRequest = error.config;
      
      if (error.response && error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        
        try {
          const response = await axios.post('/api/community/refreshToken');
          
          if (response.data && response.data.access_token) {
            localStorage.setItem('access_token', response.data.access_token);
            originalRequest.headers.common["Authorization"] = `bearer ${response.data.access_token}`;
            return jwtInterceptor(originalRequest);
          } else {
            // Token refresh failed, redirect to login
            localStorage.removeItem('access_token');
            window.location.href = '/login';
            return Promise.reject(error);
          }
        } catch (refreshError) {
          // Refresh token failed, redirect to login
          localStorage.removeItem('access_token');
          window.location.href = '/login';
          return Promise.reject(refreshError);
        }
      }
      
      return Promise.reject(error);
    }
  );
  
  export default jwtInterceptor;